import { useState, useEffect } from 'react';
import { employeeService } from '../../services/api';

const useCashierDetection = ({ authType, employeeId, username, configLoaded }) => {
    const [cashierName, setCashierName] = useState('');
    const [cashiers, setCashiers] = useState([]);

    useEffect(() => {
        const detectCashier = async () => {
            try {
                if (employeeId && employeeId.startsWith('ACC_')) {
                    setCashierName('Admin');
                } else if (authType === 'tenant' || !authType) {
                    setCashierName('Admin');
                } else if (authType === 'employee' && employeeId && !employeeId.startsWith('ACC_')) {
                    try {
                        const employees = await employeeService.getAllEmployees();
                        const employee = employees.find(emp => emp.employee_id === employeeId);
                        if (employee) {
                            setCashierName(employee.name);
                        } else {
                            setCashierName('Unknown Employee');
                        }
                    } catch (error) {
                        console.error('Failed to lookup employee:', error);
                        setCashierName('Employee');
                    }
                } else {
                    setCashierName(username || 'Staff');
                }
            } catch (error) {
                console.error('Error detecting cashier:', error);
                setCashierName('Staff');
            }
        };

        if (configLoaded) detectCashier();
    }, [authType, employeeId, username, configLoaded]);

    return { cashierName, setCashierName, cashiers, setCashiers };
};

export default useCashierDetection;
